import React, { useMemo } from 'react';
import { CSSTransition } from 'react-transition-group';
import { Formik, ErrorMessage } from 'formik';

import './styles.css';
import BasicButton from '../../../../components/BasicButton';
import BasicButtonGroup from '../../../../components/BasicButtonGroup';
import BasicLabel from '../../../../components/BasicLabel';
import BasicSubmitButton from '../../../../components/BasicSubmitButton';
import BasicTextArea from '../../../../components/BasicTextArea';
import LoadMask from '../../../../components/LoadMask';
import {ANIMATION_TIMEOUT_APPEAR} from '../../../../constants/animation';
import ENDPOINT from '../../../../constants/endpoints';
import useApi from '../../../../hooks/useApi';
import {FirmPortfolioEditCriteriaFormValidationSchema} from './validate';

const FirmPortfolioEditCriteriaForm = props => {
  const {
    params: { values: initialValues },
    actions: { proceed, dismiss, handleError },
  } = props;

  const api = useApi();

  const initialFormTitles = useMemo(() => {
    return Object.keys(initialValues)
      .filter(k => k !== 'id')
      .reduce(function(r, k) {
        return [...r, { title: k, name: k }];
      }, []);
  }, []);

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    const params = { ...values };
    Object.keys(params).forEach(k => {
      if (!params[k]) {
        params[k] = '';
      }
    });

    api.post(ENDPOINT.FORM.SAVE.FIRM_PROFILE_CRITERIA, params, {
      handleError: response => {
        setSubmitting(false);
        handleError(response, setErrors);
      },
      handleSuccess: (response) => proceed(response),
    });
  };

  return (
    <CSSTransition
      in={true}
      appear={true}
      timeout={ANIMATION_TIMEOUT_APPEAR}
      classNames="fade"
    >
      <div className="form__inner">
        <Formik
          initialValues={initialValues}
          validationSchema={FirmPortfolioEditCriteriaFormValidationSchema}
          onSubmit={onSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
          }) => (
            <form onSubmit={handleSubmit} className="form__content">
              {isSubmitting && <LoadMask />}

              {initialFormTitles.map((item) => (
                <div
                  className="form__group form__group--compact"
                  style={{
                    maxWidth: '100%',
                    marginBottom: '25px',
                  }}
                  key={item.name}
                >
                  <BasicLabel
                    name={item.name}
                    required={false}
                    text={item.title}
                    styles={{
                      fontWeight: 'bold',
                    }}
                  />
                  <BasicTextArea
                    rows={10}
                    name={item.name}
                    content={values[item.name] || ''}
                    resize={false}
                    placeholder="0 characters of the 1000 character limit"
                    controlFunc={handleChange}
                    touchFunc={handleBlur}
                    isValid={
                      (!errors[item.name] && touched[item.name]) ||
                      !touched[item.name]
                    }
                  />

                  <ErrorMessage
                    name={item.name}
                    render={message => (
                      <div className="form__error">{message}</div>
                    )}
                  />
                </div>
              ))}

              <div className="form__controls form__controls--compact">
                <BasicButtonGroup groupStyles={{ width: '100%' }}>
                  <BasicSubmitButton
                    controlFunc={handleSubmit}
                    btnWidth={200}
                    btnHeight={40}
                    btnFontWeight={500}
                    btnArrow={true}
                    btnTextColor="#27282d"
                    btnText="Save"
                  />

                  <BasicButton
                    controlFunc={dismiss}
                    btnWidth={200}
                    btnHeight={40}
                    btnFontWeight={500}
                    btnArrow={false}
                    btnTextColor="#27282d"
                    btnText="Cancel"
                  />
                </BasicButtonGroup>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </CSSTransition>
  );
};

export default FirmPortfolioEditCriteriaForm;
